module.exports = __webpack_public_path__ + "img/chinesecompany134.06e4bf87.png";